module.exports = __webpack_public_path__ + "img/image60.3ad63489.png";